<!-- Divider -->
<div
    class="hemro-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
